import { render, staticRenderFns } from "./GenderGraph.vue?vue&type=template&id=422eeed6&scoped=true"
import script from "./GenderGraph.vue?vue&type=script&lang=js"
export * from "./GenderGraph.vue?vue&type=script&lang=js"
import style0 from "./GenderGraph.vue?vue&type=style&index=0&id=422eeed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422eeed6",
  null
  
)

export default component.exports